import instance from "@/services/api/index";
import { AUTH_TYPE, PAGES } from "@/constants";
import cookiesService from "@/services/cookiesService";
import axios from "axios";

const refreshTokenEndpoint = "/auth/api/token/refresh/";
const keycloakRefreshEndpoint = "/auth/keycloak/refresh/";
const cookiesServiceInstance = cookiesService.getService();

const removeAuthAndRedirectToLogin = () => {
  cookiesServiceInstance.clearToken();
  const current =
    (window.location.pathname || "") +
    (window.location.search || "") +
    (window.location.hash || "");
  const isSafe =
    current.startsWith("/") &&
    !current.startsWith("//") &&
    !current.startsWith(PAGES.login) &&
    !current.startsWith(PAGES.loginKeycloakCallback);
  window.location.href = isSafe
    ? `${PAGES.login}?redirect=${encodeURIComponent(current)}`
    : PAGES.login;
};

const doRefresh = (endpoint, body, redirect, originalRequest) => {
  return instance(false)
    .post(endpoint, body)
    .then((res) => {
      if (res.status === 400) {
        return redirect ? removeAuthAndRedirectToLogin() : false;
      }
      if (res.status >= 200) {
        const authType = cookiesServiceInstance.getAuthType();
        cookiesServiceInstance.setToken({
          ...res.data,
          auth_type: authType || (endpoint === keycloakRefreshEndpoint ? AUTH_TYPE.keycloak : AUTH_TYPE.local),
        });
        if (originalRequest) {
          return instance(true)(originalRequest);
        }
        return true;
      }
    })
    .catch(() => {
      return redirect ? removeAuthAndRedirectToLogin() : false;
    });
};

export const refreshToken = (redirect = false, originalRequest) => {
  const refresh = cookiesServiceInstance.getRefreshToken();
  if (!refresh) {
    return redirect ? removeAuthAndRedirectToLogin() : false;
  }
  const authType = cookiesServiceInstance.getAuthType();
  const isKeycloak = authType === AUTH_TYPE.keycloak;
  const endpoint = isKeycloak ? keycloakRefreshEndpoint : refreshTokenEndpoint;
  const body = isKeycloak ? { refresh } : { refresh };
  return doRefresh(endpoint, body, redirect, originalRequest);
};

const tokenRefresher = (error) => {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    return refreshToken(true, originalRequest);
  }
  return Promise.reject(error);
};

export const handleError = (error) => {
  if (axios.isCancel(error)) {
    return Promise.resolve();
  }
  if (parseInt(error.response?.status) === 401) {
    return tokenRefresher(error);
  }
  return Promise.reject(error);
};
